import { TimeCheckWrapper } from "../style";
import { Time, TimeInOutLable } from "../CustomCalendarHeader/style";

export interface TimeCheckingProps {
  checkInTime?: string;
  checkOutTime?: string;
}

export const TimeChecking = ({
  checkInTime,
  checkOutTime,
}: TimeCheckingProps) => {
  return (
    <>
      {(checkInTime || checkOutTime) && (
        <TimeCheckWrapper dayType="timeChecking">
          <TimeInOutLable>Giờ vào ra</TimeInOutLable>
          <Time>
            {checkInTime ?? "---"} - {checkOutTime ?? "---"}
          </Time>
        </TimeCheckWrapper>
      )}
    </>
  );
};
